import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';
import { getLeaderboardFiltersKey } from '@cont/Compete/utils';
import { ALL_EXAMS, ALL_STATES } from '@cont/Compete/constants';

const useFilter = (
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();

  const key = getLeaderboardFiltersKey(query.goalUID);

  const { data, isValidating, mutate, ...rest } = useFetch(
    key,
    {},
    {
      revalidateOnMount: true,
      fallbackData: options.fallbackData
    }
  );

  const dataWithAllKey = {
    ...data,
    filters: {
      ...data.filters,
      exams: [ALL_EXAMS, ...data.filters.exams],
      states: [ALL_STATES, ...data.filters.states]
    }
  };

  return {
    key,
    data: dataWithAllKey || emptyObject,
    isValidating,
    mutate,
    ...rest
  };
};

export default useFilter;
